import React from "react";

export default function FacebookIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5 8.05c0-4.446-3.582-8.05-8-8.05C4.08 0 .498 3.604.498 8.05c0 4.017 2.926 7.347 6.75 7.95v-5.624H5.218V8.049H7.25V6.276c0-2.017 1.195-3.132 3.022-3.132.876 0 1.791.157 1.791.157v1.981h-1.009c-.994 0-1.303.62-1.303 1.257v1.51h2.218l-.354 2.327H9.75V16c3.824-.604 6.75-3.934 6.75-7.952Z"
        fill="#425893"
      />
    </svg>
  );
}
